import { faArrowLeftArrowRight } from "@jewlr/sharp-light-svg-icons/faArrowLeftArrowRight"
import { faDollarSign } from "@jewlr/sharp-light-svg-icons/faDollarSign"
import { faLeafMaple } from "@jewlr/sharp-light-svg-icons/faLeafMaple"
import { faRingsWedding } from "@jewlr/sharp-light-svg-icons/faRingsWedding"
import { faShieldCheck } from "@jewlr/sharp-light-svg-icons/faShieldCheck"
import { faTruckFast } from "@jewlr/sharp-light-svg-icons/faTruckFast"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { jewlr_t, IS_AU, IS_UK, IS_GE_CHECKOUT } from "helpers/application"
import { cn } from "styles/utils"

const getValueProps = (hasDiamondSelector, hasFreeResizing, madeInCanada) => {
  let valueProps = [
    {
      icon: faTruckFast,
      key: "shipping",
      title: hasDiamondSelector
        ? `Free Express ${jewlr_t("terms.Shipping")}`
        : `Free ${jewlr_t("terms.Shipping")}`,
    },
    {
      icon: faArrowLeftArrowRight,
      key: "returns",
      title: `${IS_GE_CHECKOUT() ? "30" : "99"}-Day Return Policy`,
    },
    {
      icon: faShieldCheck,
      key: "warranty",
      title: hasDiamondSelector ? "Lifetime Warranty" : "One-Year Warranty",
    },
  ]

  if (IS_AU() || IS_UK()) {
    valueProps.push({
      icon: faDollarSign,
      key: "duties",
      title: "Duties Included",
    })
  } else if (IS_GE_CHECKOUT() && madeInCanada) {
    valueProps.push({
      icon: faLeafMaple,
      key: "made-in-canada",
      title: "Made in Canada",
    })
  } else {
    // US & CA
    if (hasFreeResizing) {
      valueProps.push({
        icon: faRingsWedding,
        key: "resizing",
        title: "Free Ring Resizing",
      })
    } else if (madeInCanada) {
      valueProps.push({
        icon: faLeafMaple,
        key: "made-in-canada",
        title: "Made in Canada",
      })
    }
  }

  return valueProps
}

const ValuePropItem = ({ icon, title }) => (
  <div className="flex items-center gap-8">
    <FontAwesomeIcon className="text-18 h-auto w-[1em] shrink-0" icon={icon} />
    <h3 className="flex-1 py-8">{title}</h3>
  </div>
)

ValuePropItem.propTypes = {
  icon: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
}

const ValueProps = ({ pdpUgcExp }) => {
  const hasDiamondSelector = useSelector(
    (state) => state.wizard.hasDiamondSelector
  )
  const hasFreeResizing = useSelector(
    (state) => state.wizard.description.product_resizable
  )
  const madeInCanada = useSelector((state) => state.wizard.madeInCanada)

  const valueProps = getValueProps(
    hasDiamondSelector,
    hasFreeResizing,
    madeInCanada
  )

  return (
    <div
      className={cn(
        "text-14 mobile:text-16 grid grid-cols-2 gap-x-8",
        pdpUgcExp
          ? "border-grey-10 tablet:border-b-0 tablet:pb-0 mt-8 border-y py-12"
          : "my-16"
      )}
    >
      {valueProps.map((prop) => (
        <ValuePropItem icon={prop.icon} key={prop.key} title={prop.title} />
      ))}
    </div>
  )
}

ValueProps.propTypes = {
  pdpUgcExp: PropTypes.bool,
}

export default ValueProps
